import React, {Component} from 'react';
import { Container, Row, Col } from 'reactstrap';
import { sendData } from '../../analytics/sendData';
import { FormattedMessage } from 'react-intl';

class AboVerwaltung extends Component {

	componentDidMount() {
        sendData('', '', '', 'viewed', { page: 'abo-verwaltung' });
		window.scrollTo(0, 0);
	}

	render() {

		return (

			<section className="terms privacy-policy">
			<Container fluid>
				<Row>
					<Col xs="12">
						<div className="terms-title-wrap">
							<h2 className="terms-section-title">
                                Abonnement verwalten
                            </h2>
						</div>
					</Col>
				</Row>
				<Row className="no-gutters">
					<Col xs="12" className="terms-list">
                        <p className="terms-para">
                            Abo Verwaltung
                        </p>
                        <p className="terms-para">
                            Sie können das Abonnement jederzeit unter der telefonischen Hotline: 044 5816 275 oder beim E-Mail-Support <a href="mailto:gamelords.ch@silverlines.info">gamelords.ch@silverlines.info</a>
                        </p>
                    </Col>
				</Row>
			</Container>
		</section>

		);

	}

}

export default AboVerwaltung;



// WEBPACK FOOTER //
// ./src/components/StaticPages/AboVerwaltung.js